export default "__VITE_ASSET__2b659033__"